<script setup lang="ts">
import type { TpgClickEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarNavigationRailItemProps {
  iconTemplate?: IconConstant | '';
  label?: string;
  value?: string;
  loading?: boolean;
  selected?: boolean;
  slot?: 'top-items' | 'bottom-items';
}

interface GrammarNavigationRailItemSlots {
  badge?: Slot;
}

const props = withDefaults(defineProps<GrammarNavigationRailItemProps>(), {
  iconTemplate: '',
  label: '',
  loading: false,
  value: '',
  selected: false,
  slot: 'top-items',
});

const emit = defineEmits<{
  click: [event: TpgClickEvent];
}>();
const slots = defineSlots<GrammarNavigationRailItemSlots>();

function onClick(event: TpgClickEvent) {
  emit('click', event);
}
</script>

<template>
  <tpg-navigation-rail-item
    v-bind="props"
    @tpg-click="onClick"
  >
    <div
      v-if="slots.badge"
      slot="badge"
      class="flex"
    >
      <slot name="badge" />
    </div>
  </tpg-navigation-rail-item>
</template>
